// Copyright Epic Games, Inc. All Rights Reserved.

export default {
  messages: {
    "error.errorCode": "Codice errore:",
    "error.search": "Consulta la nostra knowledge base per saperne di più",
    dismiss: "chiudi",
    "installation.title": "",
    "cancelation.button": "Annulla",
  },
  errorCodes: {
    "EOS-UI-NF": {
      title: "Inizializzazione non riuscita",
      description: "Impossibile visualizzare la pagina. Contatta l'assistenza.",
    },
    "EOS-UI-UE": {
      title: "Qualcosa è andato storto.",
      description: "Qualcosa è andato storto. Contatta l'assistenza.",
    },
    "EOS-IN-BC": {
      title: "Installazione non riuscita",
      description:
        "Impossibile mostrare i progressi di installazione. Contatta l'assistenza.",
    },
    "EOS-IN-UE": {
      title: "Installazione non riuscita",
      description: "Qualcosa è andato storto. Contatta l'assistenza.",
    },
    "EOS-IN-FF": {
      title: "Installazione non riuscita",
      description:
        "Impossibile collegarsi agli Epic Online Services. Contatta l'assistenza..",
    },
    "EOS-IN-FF-*": {
      title: "Installazione non riuscita",
      description:
        "Impossibile inoltrare la richiesta agli Epic Online Services. Contatta l'assistenza.",
    },
    fallback: {
      title: "Qualcosa è andato storto.",
      description: "Qualcosa è andato storto. Contatta l'assistenza.",
    },
  },
};
